import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react';
import ReactFlow, {applyNodeChanges, Background, Controls, ReactFlowProvider} from 'react-flow-renderer';
import NodeOptions from './NodeOptions';
import Grid from '@material-ui/core/Grid';
import {Box} from '@material-ui/core';
import Skeleton from "@material-ui/lab/Skeleton";
import Tooltip from '@material-ui/core/Tooltip';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import nodeTypes from './nodes';
import generateStyle from './generateStyle';
import connectionLineComponent from './ConnectionLine';
import CustomizedDialog from '../../../atoms/cleardragbuilder';
import {useDispatch, useStore} from 'react-redux';
import EdgeDeletePopUp from './EdgeDeletePopUp';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/styles';
import {getSelectedNode, getHighlightNode, getReRender, showAcceptRejectButtons, getCollapsableSidebarStatus} from '../../../../store/global/selectors';
import DeleteClusterletAlert from '../../alerts/DeleteClusterletAlert';
import DeleteConnectionAlert from '../../alerts/DeleteConnectionAlert';
import ClonePopUp from './ClonePopUp';
import {
    toClusterletData,
    profileData,
    generateConnection,
    addProfileIdToClusterlet,
    toInstanceData,
    generateDelegatePosition,
    generateDigitalTwinPosition,
    generateAnalyticsPosition,
    generateSensorPosition,
    generateUserPosition,
    convert,
    generateTemplateClusterletPosition,
    toTemplateClueterletData,
    findDelegateNodeAndConnections,
    findExternalNodesAndConnections,
    findAbsolutePosition,
    findRelativePosition,
    findExternalNodesToBeMovedWhenInternalNodesAreMoved,
    findRelativeDimension,
    findAbsoluteDimension,
    convertLLMtoReactFlow,
    refineTheEdges,
    readjustEdges,
} from '../../../../services/reactFlowService';
import PositionService from '../../../../services/reactFlowService/position.service';
import {addClusterlet, editClusterlet} from '../../../../store/constructs/clusterlets/actions';
import {addInstance} from '../../../../store/constructs/bootloaders/actions';
import {dealWithClusterlets} from '../../../../store/undoredo/actions';
import {addClusterletConnection} from '../../../../store/constructs/clusterlet_connections/actions';
import {toggleRightDrawer, setFocusElement, setReRender, updateBlueprintSlugDetails, setTabOnFocus, openRightDrawer} from '../../../../store/global/actions';
import {getRightDrawerStatus, getNodeClicked} from '../../../../store/global/selectors';
import {internalSystem, internalSystemNodes, internalSystemNodesTypes, externalSystemNodeTypes, gapBtwRightBorderAndInternalNode, blueprintWidth, blueprintHeight} from '../../../../config/common';
import {getBlueprintDetails, getMenuAction} from '../../../../store/global/selectors';
import './contextMenu.css';
import {CreateDigitalTwinForm} from '../../DigitalTwins/CreateDigitalTwin';
import {CreateDelegateForm} from '../../delegates/CreateDelegate';
import {CreateSensorForm} from '../../sensors/CreateSensor';
import {CreateAnalyticsForm} from '../../analytics/CreateAnalytics';
import {handleSnackBar, setHighlightNode, setNodeClicked, setMenuAction} from '../../../../store/global/actions';
import {CreateUserForm} from '../../user/CreateUser';
import IconButton from '@material-ui/core/IconButton';
import {onDragStopTemplate} from '../../../../store/constructs/templated_clusterlet/actions';
import {ClusterletTemplates} from '../../clusterlet_templates/ClusterletTemplates';
import {invokeGetService, invokePostService} from '../../../../store/global/actions';
import CustomEdge from './CustomEdge';
import QueryLauncher from '../../llm/QueryLauncher';
import {Button, Typography} from '@material-ui/core';
import SystemModelSpeedDial from './nodes/themes/classic/SystemModelSpeedDial';
import LayoutService from '../../../../services/reactFlowService/layout.service';
import FlowGenerator from "../../llm/FlowGenerator";
import ModelDecider from "../../llm/ModelDecider";
import { LearnLLMButton } from '../../../atoms/buttons/LearnLLMButton';
import CircularProgress from "@material-ui/core/CircularProgress";
import LoaderWithProgress from '../../../atoms/loader/LoaderWithProgress';

let timer;

const drawerWidth = 171;


// ######################## START - Clusterlet Config swtich ###################################
const CLUSTERLET_CONFIG = {
    clusterlet: {
        title: 'Digital Twin',
        component: CreateDigitalTwinForm,
    },
    external_function: {
        title: 'Delegate',
        component: CreateDelegateForm,
    },
    analytics: {
        title: process.env.REACT_APP_ANALYTICS || 'Analytics',
        component: CreateAnalyticsForm,
    },
    sensor: {
        title: 'Sensor',
        component: CreateSensorForm,
    },
    user: {
        title: 'Enterprise App',
        component: CreateUserForm,
    },
    templated_clusterlet: {
        title: 'Template Clusterlet',
        component: ClusterletTemplates,
    },
    infer_engine: {
        title: 'Infer Engine',
        component: CreateAnalyticsForm,
    },
    learn_engine: {
        title: 'Learn Engine',
        component: CreateAnalyticsForm,
    },
    generate_engine: {
        title: 'Generate Engine',
        component: CreateAnalyticsForm,
    },
    enterprise_app_integration: {
        title: 'Enterprise App Integration',
        component: null, // add later when you have a form
    },
};
// ######################## END - Clusterlet Config swtich ###################################

const edgeTypes = {
    customButtonEdge: CustomEdge,
};

const labelNode = {
    id: 'labelNode',
    data: {label: 'blueprint'},
    type: 21,
    position: {x: internalSystem.style.width - 120, y: 10},
    zIndex: 1,
};

const controllerDelegatePosition = (internalSystem) => ({
    x: internalSystem.position.x + internalSystem.style.width / 2 - 100,
    y: internalSystem.position.y + 14,
});

const positioner = new PositionService(internalSystem);

const llmOutput = [
    [
        { name: 'crop_area', type: 'sensor' },
        { name: 'crop_gateway', type: 'HTTP/1.1 Protocol Delegate' },
        { name: 'crop', type: 'Digital Twin' },
        { name: 'crop_db_gateway', type: 'MySQL Delegate' },
        { name: 'soil_moisture', type: 'Digital Twin' },       // new
        { name: 'weather_station', type: 'Digital Twin' },     // new
    ],
    [
        { name: 'Dashboard', type: 'Enterprise App' },
        { name: 'Controller', type: 'Controller Delegate' },
        { name: 'crop', type: 'Digital Twin' },
        { name: 'crop_db_gateway', type: 'MySQL Delegate' },
        { name: 'irrigation_system', type: 'Digital Twin' },   // new
        { name: 'fertilizer_unit', type: 'Digital Twin' },     // new
    ],
];

export function SystemModel() {
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const reactFlowWrapper = useRef(null);
    const classes = generateStyle();
    const [show, setShow] = useState(false);
    const [rfNodes, setRfNodes] = useState([]);
    const [rfEdges, setRfEdges] = useState([]);
    const [templateClusterlet, setTemplateClusterlet] = useState([]);
    const {anchorEl, data, ...rest} = useSelector(getSelectedNode);
    const dispatch = useDispatch();
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    const nodeClicked = useSelector(getNodeClicked);
    const reRender = useSelector(getReRender);
    const menuAction = useSelector(getMenuAction);
    const [loading, setLoading] = useState(true);
    const [generatedLLMFlow, setGenerateLLMFlow] = useState([])

    //delete edge
    const [edgeDeletePopup, setEdgeDeletePopup] = useState(false);
    //delete node
    const [nodeDeletePopUp, setNodeDeletePopup] = useState(false);
    //clone node
    const [clonePopUp, setClonePopUp] = useState(false);

    const [clusterletType, setclusterletType] = useState('');
    const [clusterletDetails, setclusterletDetails] = useState(null);
    const [blueprintName, setBlueprintName] = useState('');
    const [conDeleteAlert, setConDelAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');
    const [isLocked, setIsLocked] = useState(false);
    const [elements, setElements] = useState([]);
    const [toggleView, setToggleView] = useState(false);
    const [preview, setPreview] = useState(false);
    const [sendTrainData, setSendTrainData] = useState(false)
    const [clusterlets, setClusterlets] = useState([]);
    const connectionStatus = useRef(false);
    const rfEdgesRef = useRef(null);
    const memoizedClusterlets = useMemo(() => clusterlets, [clusterlets]);
    const showAcceptReject = useSelector(showAcceptRejectButtons);
    const isDraggingRef = useRef(false);
    const DRAG_THRESHOLD = 5;

    const highlightNode = useSelector(getHighlightNode);
    const loaderHeight = window.innerHeight - (64 + 48 + 30);

    const collapsableSidebarStatus = useSelector(getCollapsableSidebarStatus);


    
    useEffect(() => {
        setupEntities();
        document.addEventListener('click', function () {
            if (show) setShow(false);
        });
    }, [reRender]);

    useEffect(() => {
        rfEdgesRef.current = rfEdges;
    }, [rfEdges]);

    useEffect(() => {
        if(generatedLLMFlow?.length > 0){
            manageLLMResult()
        }
    },[generatedLLMFlow])


    const manageLLMResult = async () => {
        handleAutoLayoutNodes(generatedLLMFlow)
    }

    const getSystemModelDependencies = useCallback(() => {
        return Promise.all([dispatch(invokeGetService('getSystemModelData', {})), dispatch(invokeGetService('getDelegateProtocols', []))])
            .then(([systemModelDataRes, delegateProtocolsRes]) => {
                let clusterletList = [];
                let delegateProtocols = [];

                if (systemModelDataRes?.status === true) {
                    clusterletList = addIdToConstructs(systemModelDataRes.data.clusterlets);
                    setBlueprintName(systemModelDataRes.data.blueprint.name);

                    setRfEdges(customizeEdges(addIdToConstructs(systemModelDataRes.data.clusterletConnections)));
                    dispatch(updateBlueprintSlugDetails(systemModelDataRes.data.blueprint));
                    positioner.attachClusterlets(systemModelDataRes.data.clusterlets);
                    positioner.attachEdges(systemModelDataRes.data.clusterletConnections);

                    setTemplateClusterlet(addIdToConstructs(systemModelDataRes.data.templatedClusterlets));
                }

                if (delegateProtocolsRes?.status === true) {
                    delegateProtocols = delegateProtocolsRes.data;
                }
                setClusterlets(clusterletList.filter((element) => element.type));
                return {clusterletList, delegateProtocols, blueprintName: systemModelDataRes.data.blueprint.name};
            })
            .catch((error) => {
                console.error('Error fetching system model dependencies:', error);
                throw error;
            });
    }, [dispatch]);

    const getDefaultNodes = useCallback(
        async (clusterlets, delegateProtocols) => {
            return new Promise(async (resolve, reject) => {
                clusterlets.push(labelNode);
                const clusterletsExcludeProfile = JSON.parse(JSON.stringify(clusterlets.filter((element) => element.type))).filter((clusterlet) => clusterlet.type !== 6);

                const UiElements = convert(clusterletsExcludeProfile, JSON.parse(JSON.stringify(clusterlets.filter((element) => element.source))), delegateProtocols);
                const internalSystemData = await dispatch(invokeGetService('getSystemModelConfig', []));
                
                internalSystem.data.label = blueprintName;
                UiElements.unshift(internalSystem);
                const systemModelElements = UiElements.map((element) => {
                    if (internalSystemNodes.includes(element.type)) {
                        element.parentNode = 'A';
                        element.extent = 'parent';
                        element.style = {...element.style, zIndex: 100, pointerEvents: 'none'};
                        return element;
                    }
                    if (element.type === 'external_function' || element.type === 'template_delegate') {
                        element.style = {...element.style, height2: 106, zIndex: 100, pointerEvents: 'none'};
                        return element;
                    } else if (element.type === 'sensor') {
                        element.style = {...element.style, width: 100, pointerEvents: 'none'};
                        return element;
                    } else if (element.type === 'label_node') {
                        element.style = {...element.style, fontSize: '50px'};
                        element.parentNode = 'A';
                        element.extent = 'parent';
                        element.draggable = false;
                        return element;
                    } else if (element.type === 'controller_delegate') {
                        element.draggable = false;
                        return element;
                    } else if (element.type === 'group') {
                        let newWidth = internalSystemData?.data?.configuration?.width;
                        let newHeight = internalSystemData?.data?.configuration?.height;
                        let newX = internalSystemData?.data?.configuration?.x;
                        let newY = internalSystemData?.data?.configuration?.y;

                        if (newWidth && newHeight) {
                            const {width, height} = findAbsoluteDimension({width: newWidth, height: newHeight});
                            newWidth = width;
                            newHeight = height;
                        }else{
                            newWidth = blueprintWidth;
                            newHeight = blueprintHeight
                        }

                        if (newX && newY) {
                            const {x, y} = findAbsolutePosition({x: newX, y: newY});
                            newX = x;
                            newY = y;
                        }

                        element.style = {
                            ...element.style,
                            width: newWidth || element.style.width,
                            height: newHeight || element.style.height,
                            pointerEvents: 'none'
                        };
                        element.position = {
                            ...element.position,
                            x: newX || element.position.x,
                            y: newY || element.position.y,
                        };

                        return element;
                    } else {
                        element.style = {...element.style, 
                            
                            pointerEvents: 'none'}
                        return element;
                    }
                });

                resolve(systemModelElements);
            });
        },
        [blueprintName],
    );

    const formatNodes = useCallback(
        (nodes, blueprintName) => {
            return nodes.map((node) => {
                if (highlightNode === node.id) {
                    if (node.type === 'external_function') return {...node, className: 'highlight_delegate'};
                    else if (node.type === 'sensor' || node.type === 'user') return {...node, className: 'highlight_circle', data: {...node.data, icon: node?.data?.icon}};

                    return {...node, className: 'highlight', data: {...node.data, icon: node?.data?.icon}};
                }

                if (node.type === 'sensor' || node.type === 'user') {
                    const center = positioner.getRectangleCenter();
                    const left = positioner.getRectangleLeftBorder();
                    const right = positioner.getRectangleRightBorder();
                    const x = node.position.x;
                    node.gapToBorder = x < center ? left - x : x - right;
                }

                if (nodeClicked?.id === node.id && node.id !== 'A' && node.id !== 'labelNode') {
                    if (node.type === 'clusterlet' || node.type === 'analytics') {
                        return {...node, className: 'highlight_now_dt', data: {...node.data, icon: node?.data?.icon}};
                    }

                    return {...node, className: 'highlight_now', data: {...node.data, icon: node?.data?.icon}};
                }

                if (node.id === 'A') {
                    return {...node, data: {...node.data, label: blueprintName}};
                }

                if (node.id === 'labelNode') {
                    node.data.label = blueprintName;
                    return node;
                }

                if (node.type === 'templated_clusterlet') {
                    let item = templateClusterlet.find((t) => t.id === node.id);
                    return {...node, data: {...node.data, handlers: item.metajson.connectors, clusterlet: item.id}};
                }

                return {...node, data: {...node.data, icon: node?.data?.icon}};
            });
        },
        [highlightNode, templateClusterlet, nodeClicked?.id],
    );

    const setupEntities = useCallback(
        async function () {
            getSystemModelDependencies().then(({clusterletList, delegateProtocols, blueprintName}) => {
                getDefaultNodes(clusterletList, delegateProtocols).then((modifiedNodes) => {
                    setRfNodes(formatNodes(updateAbsolutePosition(modifiedNodes), blueprintName));
                    setLoading(false);
                });
            });
        },
        [getSystemModelDependencies, getDefaultNodes, formatNodes],
    );

    const addIdToConstructs = (array) => {
        array.forEach((ele) => (ele.id = ele._id));
        return array;
    };

    useEffect(() => {
        let clusterletData = '';
        if (menuAction?.length) {
            setclusterletType(menuAction);
            let position = {x: 0, y: 0};

            if (menuAction === 'external_function') position = generateDelegatePosition({delegates: clusterlets.filter((node) => node.type === 1)});

            if (menuAction === 'clusterlet') position = generateDigitalTwinPosition({digitalTwins: clusterlets.filter((node) => node.type === 2)});

            if (menuAction === 'analytics') position = generateAnalyticsPosition({analytics: clusterlets.filter((node) => node.type === 3)});

            if (menuAction === 'infer_engine') position = generateAnalyticsPosition({analytics: clusterlets.filter((node) => node.type === 3)});

            if (menuAction === 'learn_engine') position = generateAnalyticsPosition({analytics: clusterlets.filter((node) => node.type === 3)});

            if (menuAction === 'generate_engine') position = generateAnalyticsPosition({analytics: clusterlets.filter((node) => node.type === 3)});

            if (menuAction === 'sensor') position = generateSensorPosition({sensors: clusterlets.filter((node) => node.type === 4)});

            if (menuAction === 'templated_clusterlet') position = generateTemplateClusterletPosition({templates: templateClusterlet});

            if (menuAction === 'user') position = generateUserPosition({users: clusterlets.filter((node) => node.type === 20)});

            if (menuAction === 'templated_clusterlet') {
                clusterletData = toTemplateClueterletData(menuAction, position, templateClusterlet, elements);
            } else {
                clusterletData = toClusterletData(menuAction, position, clusterlets, elements);
            }

            setclusterletDetails(clusterletData);
            dispatch(setMenuAction(null));
        }
    }, [menuAction]);

    /** Update each node with its absolute poistion */
    const updateAbsolutePosition = (nodes) => {
        return nodes.map((node) => {
            if (node.type !== 'group' && node.type !== 'label_node' && node.position && node.type != 'controller_delegate') {
                const absolutePosition = findAbsolutePosition(node.position, node.type);

                node.position = absolutePosition;
            } else if (node.type == 'controller_delegate') {
                node.position = controllerDelegatePosition(positioner.rectangle);
            } else if (node.id === 'labelNode') {
                node.position = {...node.position, x: positioner.rectangle.style.width - 120};
            }
            return node;
        });
    };

    const moveNodesInAPI = useCallback(
        function (nodes, edgesToModify = [], internalSystemNode) {
            const clusterletsPayload = nodes.map((node) => ({id: node.id, position: findRelativePosition(node.position, node.type), movedNode: true}));

            const payload = {
                clusterlets: clusterletsPayload,
                connections: edgesToModify,
                internalSystemNode: {
                    ...internalSystemNode,
                    style: {...internalSystemNode.style, ...findRelativeDimension(internalSystemNode.style)},
                },
            };
            dispatch(invokePostService('updateClusterletPosition', payload, []));
        },
        [dispatch],
    );

    const deleteConnection = useCallback(
        (edgeToDelete) => {
            setRfEdges(customizeEdges(rfEdges.filter((edge) => edge.id !== edgeToDelete?.id)));
            dispatch(invokePostService('deleteEdge', {}, [edgeToDelete?.id])).then((res) => {
                if (res?.status === true && res?.message) {
                    dispatch(handleSnackBar({open: true, message: 'Connection deleted.', severity: 'success'}));
                } else if (res?.status === false && res.message) {
                    dispatch(handleSnackBar({open: true, message: res.message, severity: 'error'}));

                    setupEntities();
                } else {
                    dispatch(handleSnackBar({open: true, message: 'Delete connection failed.', severity: 'error'}));

                    setupEntities();
                }
            });
        },
        [rfEdges, dispatch, setupEntities],
    );

    /**
     * Function used to validate the connection while created node connection
     */
    const isValidConnection = useCallback((nodes, connection) => {
        const source = nodes.find((item) => item.id === connection.source);
        const target = nodes.find((item) => item.id === connection.target);

        if (!source || !target) {
            return {valid: false, message: 'Invalid source or target node.'};
        }
        const typesMap = {
            sensor: 'Sensor',
            user: 'Enterprise app',
            controller_delegate: 'Controller',
            analytics: 'Internal Node',
            clusterlet: 'Internal Node',
            external_function: 'Delegate',
        };
        const specialTypes = ['sensor', 'user'];

        // Only validate when either source or target is sensor/user
        if (specialTypes.includes(source.type) || specialTypes.includes(target.type)) {
            const valid =
                // sensor <-> external_function
                (source.type === 'sensor' && target.type === 'external_function') ||
                (target.type === 'sensor' && source.type === 'external_function') ||
                // user <-> external_function
                (source.type === 'user' && target.type === 'external_function') ||
                (target.type === 'user' && source.type === 'external_function') ||
                // user <-> controller_delegate
                (source.type === 'user' && target.type === 'controller_delegate') ||
                (target.type === 'user' && source.type === 'controller_delegate');

            return valid
                ? {valid: true}
                : {
                      valid: false,
                      message: `Invalid connection - Can't connect ${typesMap[source.type]} to ${typesMap[target.type]}.`,
                  };
        }

        return {valid: true};
    }, []);
    /**
     * Function used to manage the boundaries of the nodes while dragging a node
     */
    const handleNodeChangeRestrictions = useCallback(
        (changes, nodes) => {
            let updatedNodes = [...nodes];
            changes.forEach((change) => {
                if (change.type === 'position' && change.position && change.dragging) {
                    const nodeIndex = updatedNodes.findIndex((n) => n.id === change.id);
                    if (nodeIndex === -1) return;

                    const node = updatedNodes[nodeIndex];
                    const movingNodeDetails = memoizedClusterlets.find((c) => c.id === change.id);
                    if (!movingNodeDetails) return;

                    const newPosition = change.position;

                    const movementDecider = positioner.isNodeAllowedToDrag(newPosition, movingNodeDetails, node);

                    const internalSystemDimensions = positioner.checkSystemModelChange(updatedNodes, node.id, internalSystemNodesTypes.includes(movingNodeDetails.type));
                    // if you want to resize "A" dynamically
                    if (internalSystemDimensions && internalSystemNodesTypes.includes(movingNodeDetails.type)) {
                        updatedNodes = updatedNodes.map((node) => {
                            const dependNode = internalSystemDimensions?.systemModelDependNodes?.find((item) => item.id === node.id);
                            if (node.id === 'A') {
                                return {
                                    ...node,
                                    style: {...node.style, width: internalSystemDimensions.width, height: internalSystemDimensions.height},
                                };
                            } else if (dependNode) {
                                return dependNode;
                            } else {
                                return node;
                            }
                        });
                    }

                    let position = movementDecider.status ? movementDecider.position : node.position;

                    if (updatedNodes[nodeIndex].gapToBorder) {
                        const center = positioner.getRectangleCenter();
                        const left = positioner.getRectangleLeftBorder();
                        const right = positioner.getRectangleRightBorder();
                        const x = position.x;
                        updatedNodes[nodeIndex].gapToBorder = x < center ? left - x : x - right;
                    }

                    // apply movement restrictions
                    updatedNodes[nodeIndex] = {
                        ...node,
                        position: movementDecider.status ? movementDecider.position : node.position,
                    };
                }
            });

            return updatedNodes;
        },
        [memoizedClusterlets],
    );

    const highlightEdges = useCallback((nodeId) => {
        setRfEdges((rfEdges) =>
            rfEdges.map((edge) => {
                if (edge.source === nodeId || edge.target === nodeId) {
                    return {...edge, style: {stroke: '#e6bb00', strokeWidth: 4}};
                } else {
                    return {...edge, style: {stroke: '#bfbfbf', strokeWidth: 3}};
                }
            }),
        );
    }, []);

    /**
     * Function used to validate, manage and save nodes on stopping the dragging of a node
     */
    const handleNodeOnPlacing = useCallback(
        (node, rfNodes) => {
            const movedNodes = [];
            const set = new Set();
            let movedNodeDetails = memoizedClusterlets.find((c) => c.id === node.id);
            if (!movedNodeDetails) return [];

            const movementDecider = positioner.isNodeAllowedToMove(node.position, movedNodeDetails);

            movedNodeDetails.position = node.position;
            const dependentPositions = positioner.findDependencyNodePositions(movedNodeDetails, memoizedClusterlets, rfEdgesRef.current, rfNodes);

            setRfEdges((prevEdges) => {
                if (!positioner.edgesToModify || positioner.edgesToModify.length === 0) {
                    return prevEdges; // no changes → bail out early
                }

                const edgesToModifyIds = new Set(positioner.edgesToModify.map((e) => e._id));

                // Remove old versions of edges that will be replaced
                const filteredEdges = prevEdges.filter((e) => !edgesToModifyIds.has(e._id));

                // Add updated/new edges
                const updatedEdges = [...filteredEdges, ...positioner.edgesToModify];

                return customizeEdges(updatedEdges);
            });

            dependentPositions.forEach((node) => {
                if (node.newPosition) {
                    movedNodes.push({
                        id: node.id,
                        type: 'position',
                        position: node.newPosition || node.position,
                    });
                }
            });

            if (movementDecider.status) {
                movedNodes.push({
                    id: node.id,
                    type: 'position',
                    position: movementDecider.position,
                });
            } else {
                movedNodes.push({
                    id: node.id,
                    type: 'position',
                    position: node.position,
                });
            }

            let updatedClusterlets = [];

            memoizedClusterlets.forEach((clusterlet) => {
                movedNodes.forEach((movedNode) => {
                    if (movedNode.id === clusterlet._id) {
                        updatedClusterlets.push({
                            ...clusterlet,
                            position: movedNode.position,
                            movedNode: true,
                        });
                        set.add(clusterlet._id);
                    }
                });

                rfNodes.forEach((node) => {
                    if (node.id === clusterlet._id && !set.has(clusterlet._id)) {
                        updatedClusterlets.push({
                            ...clusterlet,
                            position: node.position,
                            movedNode: true,
                        });
                    }
                });
            });

            const internalSystemNode = rfNodes.find((node) => node.id === 'A');
            moveNodesInAPI(updatedClusterlets, positioner.edgesToModify, internalSystemNode);

            setTimeout(() => {
                positioner.edgesToModify = [];
            });

            return movedNodes;
        },
        [memoizedClusterlets, moveNodesInAPI],
    );

	const onNodeClick = useCallback((event, element) => {
        isDraggingRef.current = false;
		dispatch(setNodeClicked({ id: element.id }));
		
		if (element.type === 'group' || element.type === 'label_node') {
			if (rightDrawerStatus) {
				dispatch(toggleRightDrawer());
			}
			return;
		}
		
		if(event.target.id === "add-profile-button" || event.target.id === "edit-profile-button"){
			dispatch(setFocusElement({ id: element.id, type: element.type, name: element?.data?.label, icon: element?.data?.icon, desc: element?.data?.desc, openSectionForm: !element.data?.profile }))
			dispatch(setTabOnFocus(2))
		}else{
			dispatch(setFocusElement({ id: element.id, type: element.type, subType: element?.data?.subType, name: element?.data?.label, protocol: element?.data?.protocol, icon: element?.data?.icon, desc: element?.data?.desc, templateId: element?.templateId ? element?.templateId : '', provenance: element?.data?.provenance }))
		}
		
		if (rightDrawerStatus === false)
			dispatch(toggleRightDrawer())
	},[dispatch, rightDrawerStatus]);


    //=================================== START - Listeners ================================
    
    const onNodeDragStart = useCallback((event, node) => {
        isDraggingRef.current = true;
    
        setRfNodes((nodes) =>
            nodes.map((item) =>
                item.id === node.id
                    ? {
                          ...item,
                          zIndex: 0,
                          data: {
                              ...item.data,
                              hovered: false,
                              showHelper: false,
                          },
                      }
                    : item
            )
        );
    }, []);
 
    
    const onNodeDragStop = useCallback(
        (_, node) => {
            isDraggingRef.current = false
            setRfNodes((nodes) => applyNodeChanges(handleNodeOnPlacing(node, nodes), nodes));
        },
        [handleNodeOnPlacing],
    );

    const onNodesChange = useCallback(
        (changes) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setRfNodes((nodes) => handleNodeChangeRestrictions(changes, nodes));
            });
        },
        [handleNodeChangeRestrictions],
    );

    

    const onConnectNodes = useCallback(
        (connection) => {
            if (connection.source === connection.target) return;

            const isValid = isValidConnection(rfNodes, connection);

            if (!isValid.valid) {
                dispatch(handleSnackBar({open: true, message: isValid.message, severity: 'error'}));
                return;
            }

            setRfEdges(customizeEdges([...rfEdges, connection]));
            dispatch(invokePostService('createEdge', {connection})).then((response) => {
                if (!response.status && response.data && response.code === 409) {
                    dispatch(handleSnackBar({open: true, message: response.message, severity: 'error'}));
                }

                setupEntities();
            });
        },
        [rfNodes, rfEdges, dispatch, setupEntities, isValidConnection],
    );

    const onConnectStart = useCallback(() => {
        connectionStatus.current = true;
    }, []);

    const onConnectEnd = useCallback(() => {
        connectionStatus.current = false;
    }, []);

    const onEdgeClick = useCallback(
        (_, edge) => {
            deleteConnection(edge);
        },
        [deleteConnection],
    );

    const onPaneClick = useCallback(() => {
        if (rightDrawerStatus) {
            dispatch(toggleRightDrawer());
            dispatch(setNodeClicked({}));
        }
    }, [rightDrawerStatus, dispatch]);

    const onNodeMouseEnter = useCallback(
        (_, node) => {
            if (isDraggingRef.current || connectionStatus.current) return;
            highlightEdges(node.id);
            setRfNodes((nodes) =>
                nodes.map((item) => {
                    if (item.id === node.id) {
                        if(node.id == 'A'){
                            return {
                                ...item,
                                // zIndex: 1000,
                                data: {...item.data, hovered: !connectionStatus.current, showHelper: true},
                            };  
                        }else{
                            return {
                                ...item,
                                zIndex: 2000,
                                data: {...item.data, hovered: !connectionStatus.current, showHelper: true},
                            };                          
                        }
                        
                    } else {
                        return {...item, data: { ...item.data, hovered: false, showHelper: false}};
                    }
                }),
            );
        },
        [highlightEdges],
    );

    const onNodeMouseLeave = useCallback((_, node) => {
        if (isDraggingRef.current) return;
        setRfEdges((rfEdges) => customizeEdges(rfEdges));
        setRfNodes((nodes) =>
            nodes.map((item) => {
                if (item.id === node.id) {
                    return {
                        ...item,
                        zIndex: 0,
                        data: {...item.data, hovered: false, showHelper: false},
                    };
                } else {
                    return item;
                }
            }),
        );
    }, []);

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);

    const onDrop = useCallback(
        (event) => {
            event.preventDefault();
            const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();

            const type = event.dataTransfer.getData('application/reactflow');
            setclusterletType(type);

            const position = reactFlowInstance.project({
                x: event.clientX - reactFlowBounds.left,
                y: event.clientY - reactFlowBounds.top,
            });

            //service to convert to the required format to store in redux

            if (type === '' || type === undefined || type === null) return;

            const clusterletData = toClusterletData(type, position, clusterlets, elements, event);
            setclusterletDetails(clusterletData);
            dispatch(setHighlightNode(clusterletData.id));
        },
        [clusterlets, dispatch, elements, reactFlowInstance],
    );

    const onInit = useCallback((_reactFlowInstance) => {
        setReactFlowInstance(_reactFlowInstance);
        setTimeout(() => {
            if (Boolean(_reactFlowInstance)) {
                //_reactFlowInstance.setViewport({zoom:0.5, position: { x: 100, y: 100 } });
                _reactFlowInstance.zoomOut();
            }
            setLoading(false);
        }, 20);
    }, []);
    //=================================== END - Listeners ================================

    const handleAutoLayoutNodes = useCallback((llmOutput) => {
        const labelNode = rfNodes.find(item => item.id === "labelNode")
        const controller = rfNodes.find(item => item.type === "controller_delegate")
        let {nodes, edges} = convertLLMtoReactFlow(llmOutput, 'A', internalSystem, labelNode, controller);

        const layoutService = new LayoutService();
        layoutService.layout(nodes, edges, internalSystem).then((layoutedNodes) => {
            let newEdges = readjustEdges(layoutedNodes, [...edges])
            edges = newEdges
            setRfEdges(customizeEdges(edges));
            setRfNodes(layoutedNodes)
        });
    },[rfNodes]);

    const addProfile = async (data, clusterlets) => {
        setShow(false);
        const profile = await profileData('profile', data, clusterlets);
        await dispatch(addClusterlet(profile, true));
        const connectionString = await generateConnection(data, profile);

        await dispatch(addClusterletConnection(connectionString, true));

        //adding the profile id to clusterlet
        const editedClusterlet = addProfileIdToClusterlet(data.id, profile.id, clusterlets);
        dispatch(editClusterlet(editedClusterlet, true));

        const instanceData = toInstanceData(profile);
        dispatch(addInstance(instanceData, true));

        //deal with clusterlet for undoredo
        const payload = profile;
        dispatch(dealWithClusterlets(payload, 'add'));
    };

    const closeDialog = () => {
        setclusterletType('');
    };

    const onClusterletAdditionComplete = (status) => {
        if (status === true) {
            dispatch(setReRender());
            dispatch(
                handleSnackBar({
                    open: true,
                    message: `${
                        clusterletType === 'clusterlet'
                            ? 'Digital Twin'
                            : clusterletType === 'external_function'
                            ? 'Delegate'
                            : clusterletType === 'analytics'
                            ? process.env.REACT_APP_ANALYTICS
                            : clusterletType === 'sensor'
                            ? 'Sensor'
                            : clusterletType === 'templated_clusterlet'
                            ? 'Template Clusterlet'
                            : clusterletType === 'infer_engine'
                            ? 'Infer Clusterlet'
                            : clusterletType === 'learn_engine'
                            ? 'Learn Clusterlet'
                            : clusterletType === 'generate_engine'
                            ? 'Generate Clusterlet'
                            : 'Enterprise App Integration'
                    } created successfully`,
                    severity: 'success',
                }),
            );
            setclusterletType('');
        }
    };

    const customizeEdges = (edges) => {
        const styledEdges = edges.map((edge) => ({
            ...edge,
            zIndex: 100,
            style: {...edge.style, stroke: '#bfbfbf', strokeWidth: 2},
            type: 'customButtonEdge',
        }));
        return styledEdges;
    };

    const trainSystemModelLLM = async () => {
        setSendTrainData(true)
        const response = await dispatch(invokeGetService('trainSystemModel',[]))
        if(!response.status){
            dispatch(handleSnackBar({open: true, message: response.message, severity: 'error'}))
        }else{
            dispatch(handleSnackBar({open: true, message: "Data submitted successfully", severity: 'success'}))
        }
        setSendTrainData(false)
    }


    const reactFlowProps = {
        nodes: rfNodes,
        edges: rfEdges,
        onNodesChange,
        onNodeDragStart,
        onNodeDragStop,
        onNodeMouseEnter,
        onNodeMouseLeave,
        onNodeClick,
        nodesDraggable: true,
        // onElementsRemove, // Nothing inside the function
        onConnect: onConnectNodes,
        connectionLineComponent,
        onDrop,
        onInit,
        onDragOver,
        nodeTypes,
        edgeTypes,
        onEdgeClick,
        onPaneClick,
        connectionMode: 'loose',
        zoomOnScroll: !isLocked,
        zoomOnPinch: !isLocked,
        fitView: true,
        onConnectStart: onConnectStart,
        onConnectEnd: onConnectEnd,
        panOnDrag: true
    };

    if (loading) {
        return (
            <Box
                position="absolute"
                top="50%"
                left={collapsableSidebarStatus ? `calc(50% + ${drawerWidth / 2}px)` : "50%"}
                textAlign="center"
                style={{ transform: "translate(-50%, -50%)" }}
            >
                <LoaderWithProgress
                    isLoader={true}
                    styleRoot={{ overflow: "hidden", height: "44px" }}
                />
    
                <Box mt={2}>
                    <Typography variant="body2" color="textSecondary">
                        Loading System Model...
                    </Typography>
                </Box>
            </Box>
        );
    }


    return (
        <>
            {/* <LearnLLMButton  
                onClick={trainSystemModelLLM} 
                disabled={sendTrainData}
            /> */}
            {/* {loading && (
                <Box
                    position="absolute"
                    top="50%"
                    // left="50%"
                    left={collapsableSidebarStatus ? `calc(50% + ${drawerWidth / 2}px)` : "50%"}
                    textAlign="center"
                    style={{ transform: "translate(-50%, -50%)" }}
                >
                    <LoaderWithProgress isLoader={true} styleRoot={{ overflow: 'hidden', height : "44px" }} />

                    <Box mt={2}>
                        <Typography variant="body2" color="textSecondary">
                            Loading System Model...
                        </Typography>
                    </Box>
                </Box>
            )} */}
            <ReactFlowProvider>
                {!preview && <NodeOptions />}
                <Grid id="eventBox" style={{ width: '100%', height: '100%' }}>
                    <div className={`dndflow ${classes.reactWrapper}`} style={{ width: '100%', position: 'relative', height: '100vh' }}>
                        <div className={classes.reactflowWrapper} ref={reactFlowWrapper}>
                            <ReactFlow {...reactFlowProps}>
                                <ControlsWrapper toggleView={toggleView} classes={classes} preview={preview} setLock={setIsLocked} isLocked={isLocked} />
                                <Background color="#c8cdd0" style={{ backgroundColor: '#dfe2e4' }} variant="dots" size={2} />
                            </ReactFlow>
                        </div>
                        {/* To add new nodes */}
                        {!preview && <SystemModelSpeedDial />} *{edgeDeletePopup && <EdgeDeletePopUp closePopUp={setEdgeDeletePopup} />}
                        {nodeDeletePopUp && <DeleteClusterletAlert onClose={setNodeDeletePopup} id={data.id} />}
                        {clonePopUp && <ClonePopUp handleClose={setClonePopUp} data={data} />}
                        <FlowGenerator setLLMFlow={setGenerateLLMFlow} />
                        {/* <QueryLauncher/> */}
                        {showAcceptReject && <ModelDecider rfNodes={rfNodes} rfEdges={rfEdges} />}
                        <CustomizedDialog open={Boolean(clusterletType)} title={`Add ${CLUSTERLET_CONFIG[clusterletType]?.title}`} handleClose={closeDialog}>
                            {(() => {
                                const Config = CLUSTERLET_CONFIG[clusterletType];
                                if (!Config || !Config.component) return null;

                                const FormComponent = Config.component;
                                return (
                                    <FormComponent
                                        clusterletType={clusterletType}
                                        clusterletDetails={clusterletDetails}
                                        addProfile={addProfile} // only needed for DigitalTwin
                                        onClose={closeDialog}
                                        onCompletion={onClusterletAdditionComplete}
                                    />
                                );
                            })()}
                        </CustomizedDialog>

                    </div>
                    {conDeleteAlert && <DeleteConnectionAlert onClose={() => setConDelAlert(false)} message={alertMsg} />}
                </Grid>
            </ReactFlowProvider>
        </>
    );
}

export default SystemModel;

const ControlsWrapper = ({classes, toggleView, preview, setIsLocked, isLocked}) => {
    const store = useStore();
    useEffect(() => {
        if (preview) {
            const {nodes} = store.getState();
            if (nodes.length) {
                const node = nodes[0];
                const x = node.__rf.position.x + node.__rf.width / 2;
                const y = node.__rf.position.y + node.__rf.height / 2;
                const zoom = 0.75;

                // setCenter(x, y, zoom);
            }
        }

        const button = document.querySelector('.react-flow__controls-interactive'); // Get the button element using its class

        // button.addEventListener('click', () => {
        // 	setIsLocked(!isLocked); // Handle the click event here
        // });
    }, [preview]);

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const toggleConfirmationDialog = () => setOpen((prev) => !prev);

    const clearDrag = () => {
        // dispatch(clearElements());
    };

    const onClear = () => {
        clearDrag();
        toggleConfirmationDialog();
    };

    return (
        <Controls className={classes.controlsPosition} showInteractive={false} onClick={(e) => alert()}>
            {!preview && (
                <React.Fragment>
                    <CustomizedDialog
                        open={open}
                        title="Drag Builder"
                        handleClose={toggleConfirmationDialog}
                        actions={
                            <React.Fragment>
                                <Button autoFocus onClick={toggleConfirmationDialog} variant="outlined" color="primary">
                                    Close
                                </Button>
                                <Button autoFocus variant="contained" color="primary" onClick={onClear}>
                                    CLEAR
                                </Button>
                            </React.Fragment>
                        }>
                        <Typography>Do you want to clear Drag builder?</Typography>
                    </CustomizedDialog>
                </React.Fragment>
            )}
        </Controls>
    );
};
